export const SIZE = [
  'extra-small',
  'small',
  'medium',
  'extra-large',
  'auto'
]

export const OBJECT_FIT = [
  'fill',
  'contain',
  'cover',
  '',
]
